export default __webpack_public_path__ + "static/media/home-print.9c3a5ae1.png";